import React, { useState } from "react";
import "../Assets/CSS/sidebar.css";
import localImages from "../Constant/localImages";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import MenuIcon from "@mui/icons-material/Menu";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../store";
import { logout } from "../store/slices/homeSlice";
interface Props {
  data: any;
}
export default function Sidebar({ data }: Props) {
  const navigate = useNavigate();
  const params = useParams<any>();
  const dispatch: Function = useDispatch<AppDispatch>();
  const [activeTab, setActiveTab] = useState<any>();
  const [activeSubTab, setSubActiveTab] = useState<any>();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const { Name } = useSelector((state: any) => ({
    Name: state?.homeReducer?.Name,
  }));
  const gotToPanel = (val: string) => {
    navigate(`${val}`);
  };
  const logOut = () => {
    dispatch(
      logout({
        callback: (res: any) => {
          if (res) {
            navigate("/");
          }
        },
        errorCallback: (error: any) => { },
      })
    );
  };
  return (
    <>
      <div className={`sidebar py-3 ${isSidebarOpen ? "" : "responisveDiv"}`}>
        <div className="SidebarlogoDiv border-bottom d-flex align-items-center p-3">
          <img
            src={localImages?.logoCircle}
            alt="logo"
            className="sidebarLogo"
          />
          <h1
            className={`Username colorWhite fw-bold ms-3 ${!isSidebarOpen ? "font18" : "font12"
              }`}
          >
            {Name}
          </h1>
        </div>
        <div className="sideBarMiddleCotainer my-2">
          <div
            className="menuBtn accordion accordion-flush"
            id="accordionFlushExample"
          >
            {data?.map((item: any, index: number) => {
              const isShow = item?.subMenu?.some((subItem: any) => subItem.path === params["*"]);
              const isShowSubMenu = item?.subMenu?.some((subItem: any) => subItem.subMenu?.some((subSubItem: any) => subSubItem.path === params["*"]));
              const shouldExpand = isShow || isShowSubMenu;
              if (item?.subMenu?.length > 0) {
                return (
                  <div className="accordion-item mb-2">
                    <h2
                      className="accordion-header"
                      id={`flush-heading${index}`}
                    >
                      <button
                        className={`accordion-button ${!shouldExpand ? "collapsed" : ""}`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#flush-collapse${index}`}
                        aria-expanded={shouldExpand ? "true" : "false"}
                        aria-controls={`flush-collapse${index}`}
                      >
                        {item.title}
                      </button>
                    </h2>
                    <div
                      id={`flush-collapse${index}`}
                      className={`accordion-collapse collapse ${shouldExpand ? "show" : ""}`}
                      aria-labelledby={`flush-heading${index}`}
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body px-0">
                        {item?.subMenu?.map(
                          (subItem: any, subIndex: number) => {
                            const isActive = subItem?.path === params["*"];
                            if (subItem?.subMenu?.length > 0) {
                              return (
                                <div
                                  className="menuBtn accordion accordion-flush"
                                  id="accordionFlushExample2"
                                >
                                  <div className="accordion-item mb-2">
                                    <h2
                                      className="accordion-header"
                                      id={`flush-heading${subItem.title.replace(/\s+/g, "-")}`}
                                    >
                                      <button
                                        className={`accordion-button ${!isShowSubMenu ? "collapsed" : ""}`}
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#flush-collapse${subItem.title.replace(/\s+/g, "-")}`}
                                        aria-expanded={isShowSubMenu ? "true" : "false"}
                                        aria-controls={`flush-collapse${subItem.title.replace(/\s+/g, "-")}`}
                                      >
                                        {subItem.title}
                                      </button>
                                    </h2>
                                    <div
                                      id={`flush-collapse${subItem.title.replace(/\s+/g, "-")}`}
                                      className={`accordion-collapse collapse ${isShowSubMenu ? "show" : ""}`}
                                      aria-labelledby={`flush-heading${subItem.title.replace(/\s+/g, "-")}`}
                                      data-bs-parent="#accordionFlushExample2"
                                    >
                                      <div className="accordion-body px-0">
                                        {subItem?.subMenu?.map((subItemMenu: any, subItemMenuIndex: number) => {
                                          const isActiveSubMenu = subItemMenu?.path === params["*"];
                                          return (
                                            <div
                                              className="subMenuBtn d-flex align-items-center"
                                              key={subItemMenuIndex}
                                            >
                                              <ul>
                                                <li
                                                  className={`font16 ${activeSubTab === subItemMenu.title || isActiveSubMenu && !activeTab ? "active" : ""}`}
                                                  onClick={() => {
                                                    setSubActiveTab(subItemMenu.title);
                                                    setIsSidebarOpen(false);
                                                    setActiveTab("");
                                                    gotToPanel(subItemMenu?.path);
                                                  }}
                                                >
                                                  <span className="me-2">
                                                    {subItemMenu.icon &&
                                                      React.createElement(subItemMenu.icon, {
                                                        className: "",
                                                      })}
                                                  </span>{" "}
                                                  {subItemMenu.title}
                                                </li>
                                              </ul>
                                            </div>
                                          )
                                        })}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )
                            } else {
                              return (
                                <div className="subMenuBtn withoutMenu" key={subIndex}>
                                  <ul>
                                    <li
                                      className={`font14 ${activeSubTab === subItem.title || isActive && !activeTab ? "active" : ""
                                        }`}
                                      onClick={() => {
                                        setSubActiveTab(subItem.title);
                                        setActiveTab("");
                                        setIsSidebarOpen(false);
                                        gotToPanel(subItem?.path);
                                      }}
                                    >
                                      {subItem.title}
                                    </li>
                                  </ul>
                                </div>
                              )
                            }
                          })}
                      </div>
                    </div>
                  </div>
                );
              } else {
                return (
                  <div className="menuBtn withoutMenu">
                    <ul>
                      <li
                        className={`font14 ${activeTab === item.title || item?.link === params["*"] && !activeSubTab ? "active" : ""}`}
                        onClick={() => {
                          setActiveTab(item.title);
                          setSubActiveTab("");
                          setIsSidebarOpen(false);
                          gotToPanel(item?.link);
                        }}
                      >
                        {item.title}
                      </li>
                    </ul>
                  </div>
                );
              }
            })}
          </div>
        </div>
        <div className="sidebarBottom colorWhite rounded-end cursor" onClick={logOut}>
          <div className="d-flex align-items-center">
            <ExitToAppIcon className="cursor" />
            <div className="ms-2 fw-bold font16">Logout</div>
          </div>
        </div>
      </div>
      {!isSidebarOpen ? (
        <div className="toggleButton" onClick={toggleSidebar}>
          <MenuIcon />
        </div>
      ) : (
        <div className="closeMenu" onClick={toggleSidebar}>
          <KeyboardBackspaceIcon />
        </div>
      )}
    </>
  );
}